import React from 'react';
import { CardDetails } from '~/lib/ApiModel';
import { Def } from '../DefTable';

import { DefTable } from '../DefTable';
import { getAppContext } from '~/lib/AppContext';
import { BillingInvoicesRoute } from '~/lib/helper/RouteHelper';
import { padStart } from '~/lib/helper/StringHelper';
import { observer } from 'mobx-react';

interface CurrentBillingDetailsProps {
    cardDetails: CardDetails | undefined;
}

@observer
export default class CurrentBillingDetails extends React.Component<CurrentBillingDetailsProps> {
    render() {
        const configuredMethods = getAppContext().customer.item?.configured_payment_methods || [];
        const hasPaypal = configuredMethods.includes('paypal');
        const hasCreditCard = configuredMethods.includes('credit-card');
        const cardDetails = this.props.cardDetails;

        if (hasPaypal) {
            return (
                <div className="currentBillingDetails mb-3">
                    <DefTable className="wide">
                        <Def name="Payment Method">PayPal</Def>
                    </DefTable>
                    <p className="text-muted mt-3">
                        <i className="ion ion-md-information-circle  me-2"></i> Please note that we do not automatically
                        charge PayPal, you will need to manually pay each invoice by clicking the pay button in the{' '}
                        <a href={BillingInvoicesRoute}>invoice list</a>.
                    </p>
                </div>
            );
        }

        if (hasCreditCard) {
            return (
                <div className="currentBillingDetailsmb-3">
                    <DefTable className="wide">
                        <Def name="Cardholder Name">{cardDetails?.cardholder || '-'}</Def>
                        <Def name="Card Type">{cardDetails?.card_type || '-'}</Def>
                        <Def name="Card Number">{cardDetails?.partial_number || '-'}</Def>
                        <Def name="Expires">
                            {cardDetails
                                ? `${padStart(cardDetails.expiry_month.toString(), 2, '0')} / ${
                                      cardDetails.expiry_year
                                  }`
                                : '-'}
                        </Def>
                    </DefTable>
                </div>
            );
        }

        return (
            <div className="currentBillingDetails text-muted">
                <p>No payment methods configured</p>
            </div>
        );
    }
}
